import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
	level: {
		"&$level&$level": {
			marginTop: "var(--spacing-x1, 4px)"
		}
	}
});
